export default {
  watchLabel: {
    id: 'rm_native_video_watch_label',
    defaultMessage: 'Watch with sound: {title}',
  },
  playLabel: {
    id: 'rm_native_video_play',
    defaultMessage: 'Play',
  },
  pauseLabel: {
    id: 'rm_native_video_pause',
    defaultMessage: 'Pause',
  },
  muteLabel: {
    id: 'rm_native_video_mute',
    defaultMessage: 'Mute',
  },
  unmuteLabel: {
    id: 'rm_native_video_unmute',
    defaultMessage: 'Unmute',
  },
  fullscreenLabel: {
    id: 'rm_native_video_fullscreen',
    defaultMessage: 'Full screen',
  },
  exitFullscreenLabel: {
    id: 'rm_native_video_exit_fullscreen',
    defaultMessage: 'Exit full screen',
  },
  closeLabel: {
    id: 'rm_native_video_close',
    defaultMessage: 'Close video',
  },
  seekLabel: {
    id: 'rm_native_video_seek',
    defaultMessage: 'Seek',
  },
} as const
